import { gql } from '@lcs/shared/api';

export const getCallLogsQuery = gql`
   query GetCallParkingLots($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      callParkingLotsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            parkerExtension {
              extensionId
              accountId
              name
              number 
            }
            parkerExtensionId   
            callerIdInformation
            parkingSlotNumber
            parkDateTime
         }
      }
   }
`;
